export default __webpack_public_path__ + "static/media/facility_03_2.09238371.png";